import { formatDate } from "@2u-landing-pages/utils";
import React from "react";
import { AutomatedContentProps } from "./AutomatedContent.types";
// @ts-ignore
import styles from "./AutomatedContent.module.scss";

type ContentType = "banner" | "tile";

type StartDatePreviewProps = Pick<
  AutomatedContentProps,
  "start_date_source" | "metaStartDate" | "pricingApiStartDate"
> & {
  contentType: ContentType;
};

export const StartDatePreview: React.FC<StartDatePreviewProps> = ({
  start_date_source,
  metaStartDate,
  pricingApiStartDate,
  contentType,
}) => {
  const value =
    start_date_source === "Program Meta (Product API)"
      ? metaStartDate
      : start_date_source === "Pricing API"
        ? pricingApiStartDate
        : null;

  if (!value) return null;

  if (contentType === "tile") {
    return (
      <div className={styles.previewTileOverlay}>
        (Preview) {start_date_source}: {formatDate(value, "US")}
      </div>
    );
  }

  return (
    <div className={styles.previewBannerContainer}>
      <div className={styles.previewBanner}>
        (Preview) {start_date_source}: {formatDate(value, "US")}
      </div>
    </div>
  );
};
